export default __webpack_public_path__ + "static/media/bae-logo-icon-contained.5e89e65e.svg";